// import Footer from "components/footer/FooterAuthDefault";
// import authImg from "assets/img/backbroundApp.png";
// import logoImg from "assets/img/logo.png";
import { Routes, Route, Navigate } from "react-router-dom";
import routes from "routes.js";
// import FixedPlugin from "components/fixedPlugin/FixedPlugin";
import "../../../src/assets/css/App.css"

export default function Auth() {
  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout === "/auth") {
        return (
          <Route path={`/${prop.path}`} element={prop.component} key={key} />
        );
      } else {
        return null;
      }
    });
  };

  //   const animationImg = (routes) => {
  //   return routes.map((prop, key) => {
  //     if (prop.path === "sign-in") {
  //             console.log(prop.path,"ddd")
  //       return (
  //            <div className="animation-img">
  //            </div>
  //       );
  //     } else if (prop.layout === "/auth" && prop.path === "foorget-password") {
  //             console.log(prop.path,"dddss")

  //       return (
  //             <div className="forgetpass-img">
  //            </div>
  //       );
  //     } 
  //     else {
  //       return null;
  //     }
  //   });
  // };

  document.documentElement.dir = "ltr";
  return (
    <div>
      <div className="relative float-right h-full min-h-screen w-full !bg-white dark:!bg-navy-900">
        {/* <FixedPlugin /> */}
        <main className={`mx-auto min-h-screen main-background`}>
          <div className="logo-img logo-hidden">
          </div>
              <div className=" flex items-center justify-center lg:max-w-[48%] xl:max-w-full auth-form">
            <div className="logo-img logo-displayOn">
          </div>

              {/* <div className="animation-img">
             </div> */}
                 <Routes>
                  {getRoutes(routes)}
                  <Route
                    path="/"
                    element={<Navigate to="/auth/sign-in" replace />}
                  />
                <Route path="/*" element={<Navigate to="/auth/not-found" replace />} />
                </Routes>
          </div>
        </main>
      </div>
    </div>
  );
}
